<template>
  <div class="default-edit_container">
    <el-scrollbar>
      <div class="default-edit">
        <ListHeader class="default-edit-header" :showVipMessage="false" :listTitle="paperObj != null ? `《${paperObj.name}》默认效果设置` : '书刊默认效果'"></ListHeader>
        <p class="item-title"><span>|</span> 参数设置</p>
        <div class="precision-setting" v-if="isPaper">
          <span class="precision-setting-title">版面图来源</span>
          <div class="precision-setting-content">
            <div class="accuracy">
              <el-radio v-model="layoutSource" :label="1">反解文件版面图</el-radio>
              <span class="introduction">解析速度快，版面清晰度取决于反解软件输出结果</span>
            </div>
            <div class="accuracy">
              <el-radio v-model="layoutSource" :label="0">PDF</el-radio>
              <span class="introduction" style="margin-left: 72px">解析速度慢，需等待PDF转换，但版面清晰</span>
            </div>
          </div>
        </div>
        <div class="precision-setting">
          <span class="precision-setting-title">当前精度</span>
          <div class="precision-setting-content">
            <div class="accuracy">
              <el-radio v-model="dpi" :label="180">高清模式</el-radio>
              <span class="introduction">书刊上传速度最快，阅读流畅度最佳</span>
            </div>
            <div class="accuracy">
              <el-radio v-model="dpi" :label="300">超清模式</el-radio>
              <span class="introduction">上传速度稍慢于高清，但转化后的清晰度最佳</span>
            </div>
          </div>
        </div>
        <p class="item-title" v-if="isPaper"><span>|</span> 基础设置</p>
        <div class="base">
          <EditBase v-if="isPaper" :isDefault="true" ref="editBase"></EditBase>
        </div>
        <p class="item-title">
          <span class="title">|</span> 背景模板
          <button class="set-btn" @click="batchSet('background')">批量修改已发布作品</button>
        </p>
        <EditBg ref="editBg" :isDefault="true"></EditBg>
        <p class="item-title">
          <span class="title">|</span> 个性设置
          <button class="set-btn" @click="batchSet('personal')">批量修改已发布作品</button>
        </p>
        <div class="personal">
          <EditPersonal ref="editPersonal" :isBaozhi="isPaper" :paper-obj="paperObj" :isDefault="true" @checkcallback="checkCallback" @adornmentMsn="adornmentMsn"></EditPersonal>
        </div>
        <p class="item-title"><span>|</span> {{ isPaper ? '报纸运营' : '书刊运营' }}</p>
        <div class="run">
          <EditPerRun ref="editPerRun" :isPaper="isPaper" :isDefault="true" @saveRunThen="saveThen" @checkcallback="questionaireCheckCallback"></EditPerRun>
        </div>
      </div>
    </el-scrollbar>
    <div class="default-edit-footer" id="edit-footer">
      <div class="edit-footer-item left" @click="saveThen()">保存并应用设置</div>
      <div class="edit-footer-item right" v-if="isPaper" @click="goBack()">返回</div>
    </div>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions" :appendToBody="true"></tip-dialog>
    <tip-dialog ref="confirmDialog" :dialog-options="confirmDialogOptions" :show-close="false" @clickCancel="cancelSet" @clickConfirm="saveThen" :appendToBody="true"></tip-dialog>
  </div>
</template>

<script>
import accuracy from '@api/accuracy'
import { getStrByteCount, isPureNum } from '@/utils'
import ListHeader from '@components/list/listHeader'
import compareVipRight from '@components/common/compareVipRight.js'
import EditBg from '../editDrawer/edit/EditBg.vue'
import EditPersonal from '../editDrawer/edit/EditPersonal.vue'
import EditPerRun from '../editDrawer/edit/EditPerRun.vue'
import EditBase from '../editDrawer/edit/EditBase.vue'
import { getDefaultSetting, editDefaultSetting, batchModifyBg, batchModifySetting } from '@api/setBook'
import paperApi from '@api/paperManager'
import apis from '@api/setBook'
import { isLogin, base64ToFile, sliceStrPicUrl } from '@/utils'
import TipDialog from '@components/common/TipDialog'

export default {
  name: 'defaultEdit',
  mixins: [compareVipRight],
  data() {
    return {
      id: '',
      zsNum: 0,
      adornment: '',
      dpi: 180,
      layoutSource: 0,
      checkReason: false,
      questionaireCheckReason: false, //临时：问卷有不符合要求的数据时，弹出的提示与其他的不一致
      batchType: '',
      confirmDialogOptions: {
        // 弹框类型
        type: 'confirm',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '您发布的所有作品，将更换为您当前设置的个性设置，是否修改？'
      }
    }
  },
  props: {
    paperObj: {
      type: Object,
      default: null
    },
    isPaper: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TipDialog,
    ListHeader,
    EditBg,
    EditPersonal,
    EditPerRun,
    EditBase
  },
  computed: {
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    },
    bookObj() {
      return this.$store.state.config.bookObj
    },
    posterBook() {
      return this.$store.state.config.poster.book
    }
  },
  methods: {
    checkCallback(value) {
      this.checkReason = value
    },
    questionaireCheckCallback(value) {
      this.questionaireCheckReason = value
    },
    adornmentMsn(value) {
      this.adornment = value
    },
    getSetting() {
      this.$store.commit('config/UPDATE_TITLE_MESSAGE', '')
      let currentApi = this.isPaper ? paperApi.getDefaultSetting(this.paperObj !== null ? this.paperObj.id : '') : getDefaultSetting()
      currentApi.then(async (res) => {
        if (res.status === 200 && res.data.status === 0 && res.data.data != null) {
          let data = res.data.data
          this.id = data.id
          this.dpi = data.dpi
          //背景
          if (data.backgroud) {
            if (data.backgroud.length === 1 || data.backgroud.length === 2) {
              this.$store.commit('config/UPDATE_CURRENT_BGIMG', 'template')
              this.$store.commit('config/UPDATE_CURRENT_BG', require('@imgs/bg' + data.backgroud + '.png'))
            } else {
              this.$store.commit('config/UPDATE_CURRENT_BGIMG', 'custom')
              this.$store.commit('config/UPDATE_CURRENT_BG', data.backgroud)
            }
          }
          if (data.displayOrNot) {
            this.$store.commit('config/UPDATE_DISPLAY_OR_NOT', JSON.parse(data.displayOrNot))
          }
          // 主页&历史资源
          this.$store.commit('config/UPDATE_OFFICIALWEB', data.officialWeb)
          this.$store.commit('config/UPDATE_LANGUAGE', data.language)
          this.$store.commit('config/UPDATE_HOMEPAGE_TITLE', data.homePageTitle)
          this.$store.commit('config/UPDATE_HOMEPAGE_URL', data.homePageUrl)
          this.$store.commit('config/UPDATE_HISTORY_RESOURCE', data.historyResource)
          this.$store.commit('config/UPDATE_ENTRY_NAME', data.entryName)
          this.$store.commit('config/UPDATE_ENTRY_URL', data.entryUrl)
          this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'voiceSpeed', val: data.voiceSpeed })
          this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'userVoiceSpeed', val: data.userVoiceSpeed })
          this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'sentenceRead', val: data.sentenceRead })
          this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'copyText', val: data.copyText })
          //导购链接
          if (await this.compareRight({ type: 'boole', key: 'buyLink' })) {
            this.$store.commit('config/SHOP', data.shop)
            this.$store.commit('config/BUY_LINK', data.buyLink)
            this.$store.commit('config/BUY_ICON_TYPE', data.shoppingGuideLinkIconOption)
            if (data.shoppingGuideLinkIconOption == -1 || data.shoppingGuideLinkIconOption >= 20) {
              this.$store.commit('config/BUY_ICON', data.shoppingGuideLinkIcon)
            } else {
              this.$store.commit('config/BUY_ICON', data.shoppingGuideLinkIconOption)
            }
            this.$store.commit('config/PCBUY_LINKNAME', data.pcBuyLinkName)
          }
          if (await this.compareRight({ type: 'boole', key: 'charge' })) {
            this.$store.commit('config/CHARGE', { type: 'bookObj', value: data.charge })
            if (data.chargeIcon && data.chargeIcon.indexOf('{') > -1) {
              let option = JSON.parse(data.chargeIcon)
              this.$store.commit('config/CHARGE_ICON', { type: 'bookObj', value: option.text })
              this.$store.commit('config/CHARGE_ICON_TYPE', option.style)
            } else if (data.chargeIcon && data.chargeIcon.length > 2) {
              this.$store.commit('config/CHARGE_ICON_TYPE', -1)
              this.$store.commit('config/CHARGE_ICON', { type: 'bookObj', value: data.chargeIcon })
            } else {
              this.$store.commit('config/CHARGE_ICON_TYPE', parseInt(data.chargeIcon))
              this.$store.commit('config/CHARGE_ICON', { type: 'bookObj', value: data.chargeIcon })
            }
          }
          //问卷
          if (await this.compare({ type: 'boole', key: 'questionnaire' })) {
            this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionnaire', value: data.questionnaire })
            if (data.questionIcon == -1 || data.questionIcon >= 20) {
              this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionIcon', value: data.questionnaireIcon })
            } else {
              this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionIcon', value: data.questionIcon })
            }
            this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionIconType', value: data.questionIcon })
            this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionType', value: data.questionType })
            let questionContent = data.questionnaire === 1 && data.questionType === 0 && data.questionContent ? JSON.parse(data.questionContent) : {}
            let questionContentConstruction = data.questionnaire === 1 && data.questionType === 0 && data.questionContent ? JSON.parse(questionContent.construction) : []
            this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionContentLink', value: data.questionContentLink })
            this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionContent', value: questionContent })
            this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionContentConstruction', value: questionContentConstruction })
            this.$store.commit('config/PCQUESTION_NAME', data.pcQuestionName)
          }
          this.adornment = data.adornment
          let colorContent =
            data.colorSwitch === 1 && data.colorContent
              ? JSON.parse(data.colorContent)
              : { 'top-nav': '#FFFFFF', 'top-txt': '#000000', 'top-icon': 1, 'mobile-nav': '#3A3A3A', 'mobile-txt': '#FFFFFF', 'mobile-icon': 0 }
          this.$store.commit('config/UPDATE_COLOR_CONTENT', colorContent)
          this.$store.commit('config/UPDATE_COLOR_SWITCH', data.colorSwitch)
          if (this.isPaper) {
            this.layoutSource = data.layoutSource
            this.$nextTick(() => {
              this.$refs.editPersonal.downloadValue = data.downloadScope
              this.$store.commit('config/UPDATE_DOWNLOADFORMAT', data.downloadFormat)
              this.$store.commit('config/UPDATE_DOWNLOADSCOPE', data.downloadScope)
              this.$refs.editPersonal.valuationDownloadStatus(data.downloadFormat)
              this.$refs.editBase.shareTitle = data.shareTitle
              this.$refs.editBase.shareDesc = data.description
              this.$refs.editBase.thumbnail = data.thumbnail
              this.$refs.editBase.showName = data.showBaoZhiName === 1
              this.$refs.editBase.showDate = data.showQiKan !== 0
              this.$refs.editBase.dateFormat = data.showQiKan !== 0 ? data.showQiKan : ''
              this.$refs.editBase.showDateFront = data.priorQiKan === 1
            })
          } else {
            this.$store.commit('config/UPDATE_BOOKBINDING', data.bookBinding)
          }
        }
      })
    },
    async setbgMusic() {
      let params = new FormData()
      const audioFile = this.$refs.editPersonal.audioFile
      params.append('fieldName', 'mp3')
      params.append('mp3', audioFile)
      //TODO 单本书设置,需修改
      params.append('id', this.id)
      return apis.uploadMusic(params)
    },
    batchSet(type) {
      if (!this.compare({ type: 'boole', key: 'batchModifySetting' })) {
        this.$refs.memberDialog.visible = true
        this.batchType = ''
        return
      }
      this.confirmDialogOptions.tip = `您发布的所有作品，将更换为您当前${type === 'background' ? '选择的背景模板' : '设置的个性设置'}，是否修改？`
      this.batchType = type
      this.$refs.confirmDialog.visible = true
    },
    cancelSet() {
      this.batchType = ''
    },
    saveThen() {
      // goToWhere表示保存后的操作 （curPage | goList）
      this.$refs.editPersonal.pauseAudio()
      isLogin()
      const { selPoster, customTit, downloadValue, pdfStatus, zipStatus, epubStatus } = this.$refs.editPersonal
      if (selPoster == 1 && !customTit) {
        this.$message({
          message: '请设置风格名称',
          type: 'error'
        })
        return
      }
      if (this.bookObj.voiceSpeed === 3 && (this.bookObj.userVoiceSpeed < 1 || this.bookObj.userVoiceSpeed > 100 || !this.bookObj.userVoiceSpeed || this.bookObj.userVoiceSpeed % 1 !== 0)) {
        this.$message({
          message: '请设置自定义语速，输入1-100整数',
          type: 'error'
        })
        return
      }
      // 若选择可下载，则必须选择至少一种类型
      if (downloadValue !== 0 && !pdfStatus && !zipStatus && !epubStatus && this.isPaper) {
        this.$message({
          message: '请至少选择一项开放文件下载类型',
          type: 'error'
        })
        return
      }
      let reg = /<[^>]+>/g
      if (reg.test(this.bookObj.shareTitle)) {
        this.$message({
          message: '标题不允许输入标签',
          type: 'error'
        })
        return
      }
      this.saveData()
    },
    async saveData() {
      let bgMusic = null
      if (this.$refs.editPersonal.audioFile) {
        const result = await this.setbgMusic()
        if (result && result.data.code === 0) {
          bgMusic = sliceStrPicUrl(result.data.data)
        }
      } else {
        bgMusic = sliceStrPicUrl(this.bookObj.bgMusic || '')
      }
      this.$refs.editPersonal.check()
      this.$refs.editPerRun.check()
      let thumbnail = ''
      if (this.isPaper) {
        if (this.bookObj.thumbnail && this.bookObj.thumbnail.includes('data:image')) {
          thumbnail = await this.picChangeUrl('thumbnail', this.bookObj.thumbnail)
        } else {
          thumbnail = this.bookObj.thumbnail === 'default' || this.bookObj.thumbnail === null ? '' : sliceStrPicUrl(this.bookObj.thumbnail)
        }
      }

      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (this.checkReason && this.questionaireCheckReason) {
            let currentBgUrl = this.bookObj.currentBgUrl
            let curBgIndex = currentBgUrl ? currentBgUrl.split('.')[0].split('/bg')[1] : null
            let finalBg = curBgIndex
            if (isNaN(parseFloat(curBgIndex)) || this.bookObj.currentBgImg === 'custom') {
              if (currentBgUrl && currentBgUrl.length > 0) {
                finalBg = handleStr(currentBgUrl)
              }
            }
            let logo = null
            let replacepc
            if (this.$refs.editPersonal.logo == 0) {
              logo = 'logo.png'
            } else if (this.$refs.editPersonal.logo == 1) {
              let judgeLogoThumbnail = this.$store.state.config.logoThumbnail
              if (judgeLogoThumbnail && judgeLogoThumbnail.length > 0) {
                logo = judgeLogoThumbnail.slice(judgeLogoThumbnail.indexOf('attach/'))
              }
              const pcurl = this.$store.state.config.pcLogo
              replacepc = handleStr(pcurl)
            }
            // 过渡页加载图片
            let loadPic = null
            if (this.$refs.editPersonal.loadPic == 0) {
              loadPic = 'logo.png'
            } else if (this.$refs.editPersonal.loadPic == 1) {
              let judgeLoadingPic = this.$store.state.config.book.loadingPic
              if (judgeLoadingPic && judgeLoadingPic.length > 0) {
                loadPic = judgeLoadingPic.slice(judgeLoadingPic.indexOf('attach/'))
                // logo = handleStr(judgeLoadingPic)
              }
            }
            // const posterPic = sliceStrPicUrl(this.$refs.editPersonal.cusImg || 'poster.png')
            let posterPic = handleStr(this.$refs.editPersonal.cusImg) || 'poster.png'
            const questionaireData = this.$refs.editPerRun.getData().questionaireData
            let shoppingGuideLinkIcon = ''
            if (this.bookObj.buyIcon && this.bookObj.buyIcon.length && this.bookObj.buyIcon.length > 0) {
              shoppingGuideLinkIcon = this.bookObj.buyIcon.substring(this.bookObj.buyIcon.indexOf('attach/'))
            }
            let buyIconLen = getStrByteCount(this.bookObj.buyIcon)
            let questionIconLen = getStrByteCount(this.bookObj.questionIcon)
            if ((this.bookObj.buyIconType >= 20 && (buyIconLen > 12 || buyIconLen < 1)) || (this.bookObj.questionIconType >= 20 && (questionIconLen > 12 || questionIconLen < 1))) {
              this.$message({ message: '未按要求输入文字内容', type: 'error' })
              return
            }
            let chargeIcon = ''
            if (this.bookObj.chargeIconType >= 20) {
              chargeIcon = JSON.stringify({
                style: this.bookObj.chargeIconType,
                text: this.bookObj.chargeIcon
              })
              let chargeIconLent = getStrByteCount(this.bookObj.chargeIcon)
              if (chargeIconLent > 12 || chargeIconLent < 1) {
                this.$message({ message: '未按要求输入文字内容', type: 'error' })
                return
              }
            } else if (this.bookObj.chargeIconType !== -1) {
              chargeIcon = this.bookObj.chargeIconType
            } else if (this.bookObj.chargeIcon && this.bookObj.chargeIcon.length && this.bookObj.chargeIcon.length > 0) {
              chargeIcon = this.bookObj.chargeIcon.substring(this.bookObj.chargeIcon.indexOf('attach/'))
            }
            function handleStr(pcurl) {
              if (pcurl) {
                return pcurl.substring(pcurl.indexOf('attach'))
              } else {
                return ''
              }
            }
            console.log(this.bookObj)
            let editParams = {
              id: this.id,
              creator: localStorage.getItem('username'),
              backgroud: finalBg,
              openSound: this.bookObj.soundOn ? 1 : 0,
              pageSound: this.bookObj.soundId,
              voiceNumber: this.bookObj.voiceNumber,
              //
              buttonStyle: this.bookObj.buttonStyle,
              bookBinding: this.bookObj.bookBinding,
              shop: this.bookObj.shop,
              buyLink: this.bookObj.buyLink,
              shoppingGuideLinkIconOption: this.bookObj.buyIconType,
              shoppingGuideLinkIcon: shoppingGuideLinkIcon,
              //
              loadEffect: this.bookObj.loadingId,
              loadText: this.bookObj.ruleForm.loadingText,
              loadColor: this.bookObj.loadingColor,
              openCatalog: 0,
              charge: this.bookObj.charge,
              chargeIcon: chargeIcon,
              price: 0.0,
              chargeIndex: 1,
              adornment: this.adornment ? this.adornment.substring(this.adornment.indexOf('attach/')) : '',
              logo: logo,
              jump: this.$refs.editPersonal.logoUrlOpen,
              url: this.$refs.editPersonal.logoUrl,
              longPress: this.$refs.editPersonal.longPress,
              navbarSwtich: this.$refs.editPersonal.navbarSwtich,
              loadPic: loadPic, //电子书加载图片
              autoPageTurn: 0,
              pageTurnInterval: null,
              poster: this.$refs.editPersonal.isPoster,
              posterStyle: this.$refs.editPersonal.selPoster,
              posterTitle: this.$refs.editPersonal.selPoster == 0 ? '' : this.$refs.editPersonal.customTit,
              posterPic: posterPic,
              posterQrCodeShow: this.posterBook.posterQrCodeShow,
              posterNameShow: this.posterBook.posterNameShow,
              posterName: this.posterBook.posterName,
              posterTextShow: this.posterBook.posterTextShow,
              posterPromptText: this.posterBook.posterPromptText,
              posterCover: this.posterBook.posterCover.toString(),
              bgMusic: this.$refs.editPersonal.bgMusic ? bgMusic : '',
              bgMusicSwitch: this.$refs.editPersonal.bgMusic,
              bgMusicLoop: this.$refs.editPersonal.circulatePlay,
              buyIcon: this.bookObj.buyIcon,
              bgMusicName: this.$refs.editPersonal.audioFileName || '背景音乐',
              dpi: this.dpi,
              displayOrNot: JSON.stringify(this.bookObj.displayOrNot),
              articleLayout: this.$refs.editPersonal.articleLayout, //// 分享文章是否带版面图，默认0；0-否，1-是
              articleHighlight: this.$refs.editPersonal.articleHighlight, //[版面图中]文章区域是否高亮，默认0；0-否，1-是
              colorSwitch: this.bookObj.colorSwitch,
              voiceSpeed: this.bookObj.voiceSpeed,
              userVoiceSpeed: this.bookObj.userVoiceSpeed,
              sentenceRead: this.bookObj.sentenceRead,
              copyText: this.bookObj.copyText,
              language: this.bookObj.language,
              winEffect: this.bookObj.winEffect
            }
            if (this.bookObj.colorSwitch === 1) {
              editParams.colorContent = JSON.stringify(this.bookObj.colorContent)
            }
            if (questionaireData.questionnaire === 1) {
              editParams = { ...editParams, ...questionaireData }
            } else {
              editParams = { ...editParams, questionnaire: questionaireData.questionnaire }
            }
            if (this.isPaper) {
              editParams.baozhiId = this.paperObj.id
              editParams.description = this.bookObj.shareDesc
              editParams.thumbnail = thumbnail
              editParams.shareTitle = this.bookObj.shareTitle
              editParams.showBaoZhiName = this.$refs.editBase.showName ? 1 : 0
              editParams.showQiKan = this.$refs.editBase.showDate ? (this.$refs.editBase.dateFormat !== '' ? this.$refs.editBase.dateFormat : 1) : 0
              editParams.priorQiKan = this.$refs.editBase.showDateFront ? 1 : 0
              editParams.homePageUrl = this.bookObj.officialWeb ? this.bookObj.homePageUrl : ''
              editParams.homePageTitle = this.bookObj.officialWeb ? this.bookObj.homePageTitle : ''
              editParams.historyResource = this.bookObj.historyResource
              editParams.entryName = this.bookObj.historyResource ? this.bookObj.entryName : ''
              editParams.entryUrl = this.bookObj.historyResource ? this.bookObj.entryUrl : ''
              editParams.officialWeb = this.bookObj.officialWeb
              editParams.layoutSource = this.layoutSource

              // 下载设置参数
              const download = this.$refs.editPersonal.downloadValue
              const formatList = download == 0 ? '' : this.$refs.editPersonal.formatList.toString()
              editParams.downloadScope = download
              editParams.downloadFormat = formatList
            }
            if (this.paperObj !== null && this.paperObj.style) {
              // 传统样式
              editParams.pcBuyLinkName = this.bookObj.pcBuyLinkName?.trim() || '导购'
              editParams.pcLogo = replacepc
              editParams.pcQuestionName = this.bookObj.pcQuestionName?.trim() || '问卷'
            }
            console.log(this.bookObj)
            const requestHandler = (res) => {
              if (res && res.data && (res.data.code === 0 || res.data.status === 0)) {
                this.$alert('保存成功', '提示', {
                  confirmButtonText: '确定'
                })
                resolve()
                return res.data
              } else {
                this.$alert('保存失败', '提示', {
                  confirmButtonText: '确定'
                })
                return Promise.reject('error')
              }
            }
            // api 请求直接失败
            const errorHandler = () => {
              return Promise.reject('error')
            }
            let currentApi
            if (this.batchType === 'background') {
              currentApi = this.isPaper ? paperApi.setPaperDefaultBg : batchModifyBg
            } else if (this.batchType === 'personal') {
              currentApi = this.isPaper ? paperApi.setPaperDefaultPersonal : batchModifySetting
            } else {
              currentApi = this.isPaper ? paperApi.setPaperDefaultSetting : editDefaultSetting
            }
            currentApi(editParams).then(requestHandler, errorHandler)
            this.batchType = ''
          } else {
            if (!this.checkReason) {
              this.$alert(this.saveErrorMessage, '提示', {
                confirmButtonText: '确定'
              })
            } else if (!this.questionaireCheckReason) {
              this.$message({ message: '请完成读者在线问卷设置', type: 'error' })
            }
            reject()
          }
        }, 0)
      })
    },
    async picChangeUrl(payload, data) {
      const result = await this.setBackgroundCustom(payload, data)
      if (result && result.data.code === 0) {
        return result.data.data
      }
    },
    async setBackgroundCustom(payload, data) {
      let params = new FormData()
      let waitData = null
      if (payload !== 'background') {
        waitData = base64ToFile(data) || ''
      } else {
        waitData = data
      }
      params.append('fieldName', payload)
      params.append(payload, waitData)
      return apis.uploadPicture(params)
    },
    cleanData() {
      this.$store.commit('config/UPDATE_CURRENT_BGIMG', 'template')
      this.$store.commit('config/UPDATE_CURRENT_BG', '')
      this.$store.commit('config/SHOP', 0)
      this.$store.commit('config/BUY_LINK', '')
      this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionnaire', value: 0 })
      this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionIcon', value: 0 })
      this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionIconType', value: 0 })
      this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionType', value: 0 })
      this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionContentLink', value: null })
      this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionContent', value: [] })
      this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionContentConstruction', value: [] })
      this.$store.commit('config/UPDATE_TITLE_MESSAGE', '')
      this.$store.commit('config/UPDATE_TITLE_DESC', '')
      this.$store.commit('config/UPDATE_THUMBNAIL', 'default')
      this.$store.commit('config/UPDATE_LONG_PRESS', 1)
      this.$store.commit('config/UPDATE_NAVBAR_SWITCH', 0)
      this.$store.commit('config/BUY_ICON', 0)
      this.$store.commit('config/BUY_ICON_TYPE', 1)
      this.$store.commit('config/CHARGE', { type: 'bookObj', value: 0 })
      this.$store.commit('config/CHARGE_ICON', { type: 'bookObj', value: 0 })
      this.$store.commit('config/CHARGE_ICON_TYPE', 0)
      this.$store.commit('config/UPDATE_VOICE_NUMBER', 1)
      this.$store.commit('config/UPDATE_BOOKBINDING', 0)
      this.$store.commit('config/UPDATE_DISPLAY_OR_NOT', { login: 1, collect: 1, thumbnail: 1, catalog: 1, search: 1, share: 1, help: 1 })
      this.$store.commit('config/UPDATE_COLOR_CONTENT', { 'top-nav': '#FFFFFF', 'top-txt': '#000000', 'top-icon': 1, 'mobile-nav': '#3A3A3A', 'mobile-txt': '#FFFFFF', 'mobile-icon': 0 })
      this.$store.commit('config/UPDATE_COLOR_SWITCH', 0)
      this.$store.commit('config/UPDATE_LANGUAGE', 0)
      this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'listenStyle', val: 0 })
      this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'voiceSpeed', val: 0 })
      this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'userVoiceSpeed', val: null })
      this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'sentenceRead', val: 0 })
      this.$store.commit('config/UPDATE_BOOK_ITEM', { name: 'copyText', val: 1 })
    },
    goBack() {
      this.$emit('goBack')
    }
  },
  created() {
    this.cleanData()
    this.getSetting()
  },
  destroyed() {
    this.cleanData()
  }
}
</script>
<style lang="scss" scoped>
.el-scrollbar {
  height: calc(100vh - 160px);
}
.default-edit_container {
  height: calc(100vh - 120px);
}
.default-edit {
  width: 100%;
  height: 100%;
  padding: 0 0 0 47px;
  .personal {
    /*height: 312px;*/
  }
  .default-edit-header {
    font-size: 18px;
    color: #515151;
    margin-bottom: 18px;
  }
  .item-title {
    font-size: 16px;
    color: #515151;
    span.title {
      color: #df5813;
    }
    .set-btn {
      color: #df5813;
      width: 130px;
      height: 20px;
      font-size: 12px;
      border-radius: 12px;
      border: 1px solid #df5813;
      margin-left: 10px;
    }
  }
  .precision-setting {
    display: flex;
    margin-bottom: 15px;
    .precision-setting-title {
      font-size: 14px;
      padding-top: 3px;
      width: 70px;
      margin-right: 10px;
      text-align: right;
    }
    .precision-setting-content {
      flex: 1;
      .introduction {
        font-size: 14px;
        color: #df5813;
        &.isPublic {
          margin-top: 6px;
        }
      }
      .accuracy {
        height: 30px;
      }
      &.page-setting-content {
        margin-top: 2px;
        /deep/ .page-setting-input {
          width: 179px !important;
        }
      }
      .page-setting-img {
        width: 485px;
        margin-left: -10px;
      }
    }
  }
}
.default-edit-footer {
  height: 50px;
  line-height: 36px;
  font-size: 14px;
  width: 100%;
  padding-top: 10px;
  position: fixed;
  bottom: 0;
  left: 90px;
  background-color: #ffffff;
  .edit-footer-item {
    cursor: pointer;
    display: inline-block;
    height: 36px;
    border: 1px solid #df5813;
    text-align: center;
    &.left {
      width: 132px;
      margin-left: calc(50% - 132px);
      background-color: #df5813;
      color: #fff;
    }
    &.right {
      width: 100px;
      margin-left: 30px;
    }
  }
}
</style>
